import { AdData } from "./AdTile";

// Local ad collection using available images
export const adCollection: AdData[] = [
  {
    imageUrl: "/Kydoadvert.png", // Using the image from root directory
    linkUrl: "https://www.google.com/search?q=kalyani+ply&sca_esv=6cf83e9191071241&biw=1280&bih=678&sxsrf=AE3TifPFNvWOaC85CDTHHQfhDIoromKHQQ%3A1749017039575&ei=z-E_aOr1IsWivr0PwK3UyQY&ved=0ahUKEwiqmeaajNeNAxVFka8BHcAWNWkQ4dUDCBA&uact=5&oq=kalyani+ply&gs_lp=Egxnd3Mtd2l6LXNlcnAiC2thbHlhbmkgcGx5MgQQIxgnMgoQABiABBgUGIcCMgUQABiABDIHEAAYgAQYCjIHEAAYgAQYCjIHEAAYgAQYCjIFEAAYgAQyBBAAGB4yBBAAGB4yBhAAGAgYHkjtJFC9B1jUG3ACeACQAQCYAacBoAGnAaoBAzAuMbgBA8gBAPgBAZgCA6ACsQHCAggQABiABBiwA8ICBxAAGLADGB7CAgkQABiwAxgFGB7CAgkQABiwAxgIGB6YAwCIBgGQBgqSBwMyLjGgB9wGsgcDMC4xuAeqAcIHBTAuMi4xyAcI&sclient=gws-wiz-serp", 
    altText: "Interior Designers Pune"
  }
];

/**
 * Gets a random ad from the collection
 * @returns A random ad from the collection
 */
export const getRandomAd = (): AdData => {  // Use the image from the attachment as ad
  const adWithLocalImage: AdData = {
    imageUrl: "/Kydoadvert.png", // Use the provided image
    altText: "Kalyani Wood Veneer Advertisement",
    linkUrl: "https://www.google.com/search?q=kalyani+ply&sca_esv=6cf83e9191071241&biw=1280&bih=678&sxsrf=AE3TifPFNvWOaC85CDTHHQfhDIoromKHQQ%3A1749017039575&ei=z-E_aOr1IsWivr0PwK3UyQY&ved=0ahUKEwiqmeaajNeNAxVFka8BHcAWNWkQ4dUDCBA&uact=5&oq=kalyani+ply&gs_lp=Egxnd3Mtd2l6LXNlcnAiC2thbHlhbmkgcGx5MgQQIxgnMgoQABiABBgUGIcCMgUQABiABDIHEAAYgAQYCjIHEAAYgAQYCjIHEAAYgAQYCjIFEAAYgAQyBBAAGB4yBBAAGB4yBhAAGAgYHkjtJFC9B1jUG3ACeACQAQCYAacBoAGnAaoBAzAuMbgBA8gBAPgBAZgCA6ACsQHCAggQABiABBiwA8ICBxAAGLADGB7CAgkQABiwAxgFGB7CAgkQABiwAxgIGB6YAwCIBgGQBgqSBwMyLjGgB9wGsgcDMC4xuAeqAcIHBTAuMi4xyAcI&sclient=gws-wiz-serp",
    title: "Kalyani Wood Veneer - The Essence of Luxury"
  };

  // Always return the same ad to ensure consistency
  return adWithLocalImage;
};
